import { render } from "./Feature.vue?vue&type=template&id=65ddb6f9"
import script from "./Feature.vue?vue&type=script&lang=ts"
export * from "./Feature.vue?vue&type=script&lang=ts"

import "./Feature.vue?vue&type=style&index=0&id=65ddb6f9&lang=postcss"
script.render = render

export default script